import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  IConjointQuestionModelState,
  ConjointQuestionModelTypes,
  IConjointResponseValidation,
  ConjointSubmitResponse
} from '../Conjoint/types'
import BaseQuestionModel from '../BaseQuestionModel'

const ConjointQuestionModel: IQuestionModelConstructor<ConjointQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<ConjointQuestionModelTypes, IConjointQuestionModelState>({
    questionType: QuestionType.CONJOINT,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  model.navigationFrame = [1, model.schema.answers_mask.length]
  return model
}

function submitResponse({ response }: IConjointQuestionModelState) {
  return response as ConjointSubmitResponse
}

function initState(state: IConjointQuestionModelState): IConjointQuestionModelState {
  state.response = []
  return state
}

function validateResponse({
  response,
  frame,
  questionSchema
}: IConjointQuestionModelState): IConjointResponseValidation {
  if (!questionSchema.matrix_batches.length || !questionSchema.answers_mask.length) return { valid: true }
  if (null != response[frame as number])
    return {
      valid: true
    }
  return {
    valid: false
  }
}

export default ConjointQuestionModel
